// removed by extract-text-webpack-plugin
module.exports = {"status":"_2WGG7xsmdigxpC5p9gjmpw","hasRights":"lEnH2aL2rtfkzC4o9lBTg","success":"_1vCFvfsZLD7iWPOwgajC86"};


//////////////////
// WEBPACK FOOTER
// ./src/components/YesNoStatus/YesNoStatus.scss
// module id = 1345
// module chunks = 1